@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.example.readingnotes.data.remote.api

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

// Initialize fetch with credentials on module load
private val fetchWithCredentials: Unit =
    run {
        // Override the global fetch to include credentials
        js(
            """
            (function() {
                var originalFetch = window.fetch;
                window.fetch = function(input, init) {
                    init = init || {};
                    init.credentials = 'include';
                    return originalFetch.call(this, input, init);
                };
            })();
            """,
        )
        Unit
    }

actual fun createHttpClient(baseUrl: String): HttpClient {
    // Ensure fetch is configured with credentials
    @Suppress("UNUSED_EXPRESSION")
    fetchWithCredentials

    return HttpClient(Js) {
        install(ContentNegotiation) {
            json(
                Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                },
            )
        }
        defaultRequest {
            url(baseUrl)
            contentType(ContentType.Application.Json)
        }
    }
}
